// Dedicated BOGO offer selector. All offered variants and prices are server-rendered.
// Native Shopify bundle variants still enforce physical quantities at checkout.
class SpBogoOfferPicker extends HTMLElement {
  connectedCallback() {
    if (this.bound) return;
    this.bound = this.choose.bind(this);
    this.addEventListener('change', this.bound);
    for (const radio of this.querySelectorAll('input[type="radio"]')) {
      radio.disabled = radio.dataset.optionAvailable !== 'true';
      radio.setAttribute('aria-disabled', String(radio.disabled));
    }
    queueMicrotask(() => this.choose());
  }
  disconnectedCallback() {
    this.removeEventListener('change', this.bound);
    this.bound = null;
  }
  choose() {
    const input = this.querySelector('input[type="radio"]:checked');
    if (!input || input.disabled) return;
    const section = this.closest('.shopify-section');
    if (!section) return;
    const card = input.closest('.sp-bogo-offers__card');
    const productId = this.dataset.productId;
    const variantId = input.dataset.variantId;
    if (!variantId || !/^\d+$/.test(variantId)) return;
    for (const form of section.querySelectorAll('product-form-component')) {
      if (form.dataset.productId && form.dataset.productId !== productId) continue;
      for (const field of form.querySelectorAll('input[name="id"]')) {
        field.value = variantId;
        field.dispatchEvent(new Event('change', { bubbles: true }));
      }
      // One selected offer is one complete bundle, never multiple loose toys.
      for (const field of form.querySelectorAll('input[name="quantity"]')) field.value = '1';
      for (const button of form.querySelectorAll('button[name="add"]')) {
        button.disabled = false;
        button.setAttribute('aria-disabled', 'false');
      }
    }
    const priceSource = card.querySelector('.sp-bogo-offers__price');
    for (const price of section.querySelectorAll('product-price')) {
      if (price.dataset.productId !== productId) continue;
      const target = price.querySelector('[ref="priceContainer"] .price');
      if (target && priceSource) target.innerHTML = priceSource.innerHTML;
      const compareSource = card.querySelector(".sp-bogo-offers__compare-price");
      const compareTarget = price.querySelector('[ref="priceContainer"] .compare-at-price');
      if (compareTarget) {
        compareTarget.hidden = !compareSource;
        if (compareSource) compareTarget.innerHTML = compareSource.innerHTML;
      }
    }
    for (const radio of this.querySelectorAll('input[type="radio"]')) {
      radio.dataset.currentChecked = String(radio.checked);
      radio.closest('.sp-bogo-offers__card')?.classList.toggle('quantity-breaks__card--active', radio.checked);
    }
    const url = new URL(location.href);
    url.searchParams.set('variant', variantId);
    history.replaceState(history.state, '', url);
  }
}
if (!customElements.get('sp-bogo-offer-picker')) customElements.define('sp-bogo-offer-picker', SpBogoOfferPicker);
